import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AddVendorBankDetail from './addVendorBankDetail';
import {
  getVendorBankDetailFields,
  getGeoCitiesByState,
  getGeoPincodesByCity,
  getVendorOnboardingList,
} from 'services/redux/sales/vendorPortal/action';

const mapStateToProps = (state) => ({
  vendorOnboardedList: state.vendorPortalReducer.vendorOnboardedList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getVendorBankDetailFields,
      getGeoCitiesByState,
      getGeoPincodesByCity,
      getVendorOnboardingList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddVendorBankDetail);
